import React from 'react';
import { ImainHome } from '@typings/setting/mainHome.interface';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import { HomeGrid } from '../FreeType';
import BannerSec from '../BannerSec/BannerSec';
import QuillContents from '@template/QuillContents/QuillContents';

type Props = {
  transparent?: boolean;
  contents?: string;
  showBannnerSec?: boolean;
};

function HomeNoticeSec({
  contents,
  transparent = false,
  showBannnerSec = false,
}: Props) {
  const { data, set } = useDocument<ImainHome>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINHOME}`,
  );


  return (
    <HomeGrid
      isBackground={transparent ? false : data?.backgroundSet}
      style={{ gridArea: 'notice', padding: '16px' }}
    >
      {data?.isHtmlMode && data?.htmlContents ? (
        <QuillContents value={data?.htmlContents} htmlValue={data?.htmlContents} isHtmlMode={data?.isHtmlMode} />
      ) : (
        <QuillContents value={contents || data?.contents} />
      )}
      {showBannnerSec && data?.banner?.bannerIncludeNotice && <BannerSec />}
    </HomeGrid>
  );
}

export default HomeNoticeSec;
